(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Highcharts"));
	else if(typeof define === 'function' && define.amd)
		define(["Highcharts"], factory);
	else if(typeof exports === 'object')
		exports["WkoReact"] = factory(require("Highcharts"));
	else
		root["WkoReact"] = factory(root["Highcharts"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__353__) => {
return 